import React, { useMemo } from 'react';
import DashboardStatCard from './DashboardStatCard';

const DashboardOverviewCards = ({ allGames, standings }) => {
  const stats = useMemo(() => {
    if (!allGames?.length) return null;
    const finished = allGames.filter(g => g.status?.abstractGameState === 'Final');
    let wins = 0, losses = 0, rs = 0, ra = 0, extraInn = 0, oneRun = 0;
    finished.forEach(g => {
      const bosHome = g.teams?.home?.team?.id === 111;
      const bosScore = Number(bosHome ? g.teams.home.score : g.teams.away.score);
      const oppScore = Number(bosHome ? g.teams.away.score : g.teams.home.score);
      if (bosScore > oppScore) wins++; else losses++;
      rs += bosScore; ra += oppScore;
      if ((g.linescore?.currentInning || 9) > 9) extraInn++;
      if (Math.abs(bosScore - oppScore) === 1) oneRun++;
    });
    const gp = finished.length;
    const sox = standings?.find(t => t.team?.id === 111);
    return {
      record: `${wins}–${losses}`,
      winPct: gp ? ((wins / gp) * 100).toFixed(1) + '%' : '--',
      rpg: gp ? (rs / gp).toFixed(2) : '--',
      rapg: gp ? (ra / gp).toFixed(2) : '--',
      rd: rs - ra,
      extraInn,
      oneRun,
      gb: sox?.gamesBack === '-' ? '0.0' : (sox?.gamesBack ?? '--'),
      streak: sox?.streak?.streakCode ?? '--',
      rank: standings ? standings.findIndex(t => t.team?.id === 111) + 1 : '--',
    };
  }, [allGames, standings]);

  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      <DashboardStatCard label="Season Record" value={stats.record} sub={`Win % ${stats.winPct}`} accent />
      <DashboardStatCard label="AL East Rank" value={`#${stats.rank}`} sub={`${stats.gb} GB`} accent={stats.rank === 1} />
      <DashboardStatCard label="Run Diff" value={stats.rd > 0 ? `+${stats.rd}` : stats.rd} sub="RS minus RA" accent={stats.rd > 0} />
      <DashboardStatCard label="Streak" value={stats.streak} sub="Current" accent={stats.streak?.startsWith('W')} />
      <DashboardStatCard label="Runs/Game" value={stats.rpg} sub="Offense avg" />
      <DashboardStatCard label="Runs Allowed/G" value={stats.rapg} sub="Pitching avg" />
      <DashboardStatCard label="Extra Innings" value={stats.extraInn} sub="Games past 9" />
      <DashboardStatCard label="1-Run Games" value={stats.oneRun} sub="Decided by 1" />
    </div>
  );
};

export default DashboardOverviewCards;